import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_2 = { class: "d-flex flex-wrap flex-column flex-md-row-reverse ml-auto mr-auto mr-md-1 ga-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_TimesheetSideBox = _resolveComponent("TimesheetSideBox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_date_input = _resolveComponent("v-date-input")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_NumberField = _resolveComponent("NumberField")!
  const _component_SelectField = _resolveComponent("SelectField")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_TextAreaField = _resolveComponent("TextAreaField")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_add_epic = _resolveComponent("add-epic")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_add_technology = _resolveComponent("add-technology")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.timesheet && _ctx.timesheet.id ? "Edit" : "Add") + " Timesheet ", 1),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.cancel,
                color: "red",
                size: "small",
                icon: "mdi-close"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "3",
                sm: "3",
                class: "p-0"
              }, {
                default: _withCtx(() => [
                  (!_ctx.pageLoading || !_ctx.regLoading)
                    ? (_openBlock(), _createBlock(_component_TimesheetSideBox, {
                        date: _ctx.formatedSelectedDate,
                        teamMemberInfo: _ctx.teamMemberInfo,
                        key: `s-v-${_ctx.sideBoxVersion}`,
                        commitmentColors: _ctx.commitmentColors,
                        onEditTimesheet: _ctx.editTimesheet
                      }, null, 8, ["date", "teamMemberInfo", "commitmentColors", "onEditTimesheet"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "9",
                sm: "9",
                class: "p-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    ref: "frmMain",
                    modelValue: _ctx.valid,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.valid) = $event)),
                    "lazy-validation": "",
                    class: "form-inputs"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        loading: _ctx.pageLoading || _ctx.loading,
                        disabled: _ctx.pageLoading || _ctx.loading
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "details-container mb-0 pb-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "input-label" }, " Date ", -1)),
                                      _createVNode(_component_v_date_input, {
                                        min: _ctx.minDate,
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock,
                                        "first-day-of-week": "1",
                                        rules: [_ctx.rules.required],
                                        modelValue: _ctx.timesheetModel.date,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timesheetModel.date) = $event)),
                                        "hide-actions": "",
                                        placeholder: "Date",
                                        "prepend-icon": ""
                                      }, null, 8, ["min", "readonly", "disabled", "rules", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_TextField, {
                                        id: "timesheet_register_ticket",
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock,
                                        rules: [_ctx.rules.required],
                                        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fillDescription())),
                                        placeholder: "Ticket / Issue No",
                                        label: "Ticket / Issue No",
                                        modelValue: _ctx.timesheetModel.issueNo,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.timesheetModel.issueNo) = $event)),
                                        outlined: ""
                                      }, null, 8, ["readonly", "disabled", "rules", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_NumberField, {
                                        id: "timesheet_register_effort",
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock,
                                        rules: [_ctx.rules.required, _ctx.rules.step, _ctx.rules.notZero],
                                        min: "0",
                                        max: "10",
                                        placeholder: "Effort / Hours",
                                        label: "Effort / Hours",
                                        modelValue: _ctx.timesheetModel.effort,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.timesheetModel.effort) = $event)),
                                        outlined: "",
                                        step: "0.25",
                                        showNumberIncSuggestion: ""
                                      }, null, 8, ["readonly", "disabled", "rules", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_SelectField, {
                                        id: "timesheet_register_commitment",
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock,
                                        rules: [_ctx.rules.required],
                                        label: "Commitment",
                                        items: _ctx.commitments,
                                        placeholder: "Commitment",
                                        "item-title": "Name",
                                        "item-value": "id",
                                        modelValue: _ctx.timesheetModel.commitmentId,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.timesheetModel.commitmentId) = $event)),
                                        outlined: ""
                                      }, null, 8, ["readonly", "disabled", "rules", "items", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { class: "details-container mt-0 pt-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_SelectField, {
                                        id: "timesheet_register_project",
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock || _ctx.projectLoading,
                                        rules: [_ctx.rules.required],
                                        label: "Project",
                                        placeholder: "Project",
                                        items: _ctx.projects,
                                        "item-title": "Name",
                                        "item-value": "id",
                                        modelValue: _ctx.timesheetModel.projectId,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.timesheetModel.projectId) = $event)),
                                        outlined: "",
                                        loading: _ctx.projectLoading
                                      }, null, 8, ["readonly", "disabled", "rules", "items", "modelValue", "loading"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "10",
                                    md: "5",
                                    sm: "10"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_AutoCompleteField, {
                                        id: "timesheet_register_epic",
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock || _ctx.epicLoading,
                                        rules: [_ctx.rules.required],
                                        label: "Epic",
                                        placeholder: "Epic",
                                        modelValue: _ctx.timesheetModel.epic,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.timesheetModel.epic) = $event)),
                                        items: _ctx.epicList,
                                        "item-title": "Name",
                                        "item-value": "Name",
                                        loading: _ctx.epicLoading,
                                        outlined: ""
                                      }, null, 8, ["readonly", "disabled", "rules", "modelValue", "items", "loading"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "pl-0 pr-0 align-self-center",
                                    cols: "2",
                                    md: "1",
                                    sm: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      (!_ctx.timesheetModel.isLock)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            class: "mx-2",
                                            size: "small",
                                            color: "red",
                                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showEpic = true)),
                                            disabled: !_ctx.timesheetModel.projectId,
                                            icon: "mdi-plus"
                                          }, null, 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_tooltip, {
                                        location: "top",
                                        "max-width": "500"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createElementVNode("span", _mergeProps({ class: "tooltipIcon mt-1" }, props), " ? ", 16)
                                        ]),
                                        default: _withCtx(() => [
                                          _cache[20] || (_cache[20] = _createElementVNode("p", null, [
                                            _createTextVNode(" Epics are large bodies of work that can be broken down to a number of smaller tasks or stories. Setting the right Epic makes our reporting a lot more meaningful. Some Epic examples could be: "),
                                            _createElementVNode("span", { class: "boldTooltip" }, "Tech Debt, Onboarding, March 2050 Launch, Version x, Feature ABC, Misc, Security, Performance Improvements. ")
                                          ], -1)),
                                          _cache[21] || (_cache[21] = _createElementVNode("p", null, [
                                            _createTextVNode(" There is no right or wrong way of choosing our Epics. The main point is to be able to produce high level reports on large bodies of work that the management will be interested in. For example, how much time this year was spent on "),
                                            _createElementVNode("span", { class: "boldTooltip" }, "Feature ABC"),
                                            _createTextVNode(", or "),
                                            _createElementVNode("span", { class: "boldTooltip" }, "Tech Debt"),
                                            _createTextVNode(". ")
                                          ], -1))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_SelectField, {
                                        id: "timesheet_register_activity",
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock || _ctx.epicLoading,
                                        rules: [_ctx.rules.required],
                                        placeholder: "Activity",
                                        label: "Activity",
                                        modelValue: _ctx.timesheetModel.activityId,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.timesheetModel.activityId) = $event)),
                                        items: _ctx.activityList,
                                        "item-title": "Value",
                                        "item-value": "id",
                                        outlined: "",
                                        onChange: _ctx.activityChanged
                                      }, null, 8, ["readonly", "disabled", "rules", "modelValue", "items", "onChange"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "10",
                                    md: "5",
                                    sm: "10"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_SelectField, {
                                        id: "timesheet_register_technology",
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock || _ctx.epicLoading,
                                        rules: [_ctx.rules.required],
                                        label: "Technology",
                                        placeholder: "Technology",
                                        modelValue: _ctx.timesheetModel.technologyId,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.timesheetModel.technologyId) = $event)),
                                        items: _ctx.technologyList,
                                        "item-title": "Value",
                                        "item-value": "id",
                                        outlined: ""
                                      }, null, 8, ["readonly", "disabled", "rules", "modelValue", "items"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "align-self-center pl-0 pr-0",
                                    cols: "2",
                                    md: "1",
                                    sm: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      (!_ctx.timesheetModel.isLock)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            class: "mx-2",
                                            size: "small",
                                            color: "red",
                                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showTechnology = true)),
                                            icon: "mdi-plus"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_TextAreaField, {
                                        id: "timesheet_register_description",
                                        readonly: _ctx.timesheetModel.isLock,
                                        disabled: _ctx.timesheetModel.isLock || _ctx.epicLoading,
                                        rules: [_ctx.rules.required],
                                        outlined: "",
                                        placeholder: "Description",
                                        label: "Description",
                                        modelValue: _ctx.timesheetModel.description,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.timesheetModel.description) = $event))
                                      }, null, 8, ["readonly", "disabled", "rules", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_actions, { class: "action-bottons ml-3" }, {
                            default: _withCtx(() => [
                              (_ctx.timesheetModel.isLock)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.timesheetModel.message), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_2, [
                                (!_ctx.timesheetModel.isLock)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      class: "tertiary_btn right actionButton",
                                      loading: _ctx.loading,
                                      disabled: _ctx.loading,
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.confirm(true)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                                            _createTextVNode("mdi-plus")
                                          ])),
                                          _: 1
                                        }),
                                        _cache[23] || (_cache[23] = _createTextVNode("Save and add another"))
                                      ]),
                                      _: 1
                                    }, 8, ["loading", "disabled"]))
                                  : _createCommentVNode("", true),
                                (!_ctx.timesheetModel.isLock)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      id: "timesheet_register_save_button",
                                      class: "primary_btn right actionButton",
                                      loading: _ctx.loading,
                                      disabled: _ctx.loading,
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.confirm(false)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                                            _createTextVNode("mdi-check")
                                          ])),
                                          _: 1
                                        }),
                                        _cache[25] || (_cache[25] = _createTextVNode("Save"))
                                      ]),
                                      _: 1
                                    }, 8, ["loading", "disabled"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                  class: "secondary_btn right actionButton",
                                  onClick: _ctx.cancel
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                                        _createTextVNode("mdi-close")
                                      ])),
                                      _: 1
                                    }),
                                    _cache[27] || (_cache[27] = _createTextVNode("Cancel"))
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"]),
                      (_ctx.selectedProject && _ctx.showEpic)
                        ? (_openBlock(), _createBlock(_component_v_dialog, {
                            key: 0,
                            scrollable: false,
                            modelValue: _ctx.showEpic,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showEpic) = $event)),
                            persistent: "",
                            "max-width": "600px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_add_epic, {
                                epicList: _ctx.epicList,
                                project: _ctx.selectedProject,
                                epicLoading: _ctx.epicLoading,
                                onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showEpic = false)),
                                onSuccess: _ctx.epicAdded
                              }, null, 8, ["epicList", "project", "epicLoading", "onSuccess"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_dialog, {
                        persistent: "",
                        scrollable: false,
                        "max-width": "600px",
                        modelValue: _ctx.showTechnology,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showTechnology) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_add_technology, {
                            activities: _ctx.activityList,
                            technologies: _ctx.fullTechnologyList,
                            onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showTechnology = false)),
                            onConfirm: _ctx.technologyAdded
                          }, null, 8, ["activities", "technologies", "onConfirm"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}